import { JSX, useEffect } from "react";
import { useSubscription } from "@apollo/client";
import { AgendaShiftApplication, OnCreateAgendaShiftApplicationByUserIdSubscription, OnCreateAgendaShiftApplicationByUserIdSubscriptionVariables } from "../../../graphql/API";
import { onCreateAgendaShiftApplicationByUserId } from "../queries";

const SubscriptionOpenShiftWrapper = ({ userId, onNewShift, subscriptionKey, onError }: {
    userId: string;
    onNewShift: (shift: AgendaShiftApplication) => void;
    subscriptionKey: number;
    onError?: () => void;
  }) : JSX.Element | null => {
    // console.log('userId', userId)
    const { data, error } = useSubscription<
      OnCreateAgendaShiftApplicationByUserIdSubscription, 
      OnCreateAgendaShiftApplicationByUserIdSubscriptionVariables>(onCreateAgendaShiftApplicationByUserId, {
        variables: { userId
        // , filter: {
        //   userId: {eq: userId}
        // }},
      },
        skip: !userId,
    });
  
    useEffect(() => {
      if (data?.onCreateAgendaShiftApplicationByUserId) {
        onNewShift(data.onCreateAgendaShiftApplicationByUserId as AgendaShiftApplication);
      }
    }, [data]);
  
    useEffect(() => {
        if (error) {
          console.error("Subscription error");//:", error);
          onError?.();
        }
      }, [error]);
  
    return null;
  };
 export default SubscriptionOpenShiftWrapper  